export interface MergeFileIdsResult {
  readonly desiredIds: readonly string[];
  readonly remoteChanged: boolean;
  readonly conflicts: readonly string[];
}

export function mergeFileIds(
  baseIds: readonly string[],
  localDesiredIds: readonly string[],
  latestRemoteIds: readonly string[],
): MergeFileIdsResult {
  assertExactFileIds(baseIds, 'baseIds');
  assertExactFileIds(localDesiredIds, 'localDesiredIds');
  assertExactFileIds(latestRemoteIds, 'latestRemoteIds');

  const base = new Set(baseIds);
  const local = new Set(localDesiredIds);
  const remote = new Set(latestRemoteIds);
  const locallyRemoved = new Set(baseIds.filter((id) => !local.has(id)));
  const locallyAdded = localDesiredIds.filter((id) => !base.has(id));
  const desiredIds = latestRemoteIds.filter((id) => !locallyRemoved.has(id));

  for (const id of locallyAdded) {
    if (!remote.has(id)) desiredIds.push(id);
  }

  return Object.freeze({
    desiredIds: Object.freeze(desiredIds),
    remoteChanged: !arraysEqual(baseIds, latestRemoteIds),
    conflicts: Object.freeze([]),
  });
}

function assertExactFileIds(ids: readonly string[], field: string): void {
  const seen = new Set<string>();
  for (const id of ids) {
    if (typeof id !== 'string' || id.trim().length === 0 || seen.has(id)) {
      throw new TypeError(`${field} must contain unique non-empty file ids`);
    }
    seen.add(id);
  }
}

function arraysEqual(
  left: readonly string[],
  right: readonly string[],
): boolean {
  return (
    left.length === right.length &&
    left.every((value, index) => value === right[index])
  );
}
